import { directions } from "@/mocks/mayiBaoliao";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100/70">
      {/* 纸纹层（装饰，无实景图） */}
      <div className="pointer-events-none absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(oklch(var(--secondary-500)/0.10) 1px, transparent 1px)", backgroundSize: "26px 26px" }} />

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-14 text-center md:px-6 md:py-20">
        <p className="rise-in flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.3em] text-secondary-700">
          <span className="h-px w-6 bg-secondary-400" />
          五一爆料 · 出行避坑情报站
          <span className="h-px w-6 bg-secondary-400" />
        </p>

        <h1 className="rise-in mt-6 font-heading text-5xl font-black leading-none tracking-tight text-foreground-950 sm:text-6xl md:text-7xl">
          五一爆料
          <span className="ml-3 inline-block align-middle font-sans text-base font-medium text-foreground-500 md:text-lg">
            见闻 · 实况 · 雷区
          </span>
        </h1>

        <p className="rise-in mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          汇总景区现场、游客见闻、酒店踩雷与交通拥堵实况，揭露旅游乱象，
          让你每一次假期出行都少踩坑。
        </p>

        {/* 五大方向 · 快速入口条 */}
        <div className="rise-in mt-9 flex w-full max-w-3xl flex-wrap items-stretch justify-center gap-2.5 md:gap-3">
          {directions.map((d) => (
            <a
              key={d.id}
              href="#guides"
              className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 transition hover:-translate-y-0.5 hover:border-secondary-300 hover:text-foreground-950"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className={`${d.iconClass} text-base text-secondary-600`} />
              </span>
              <span className="whitespace-nowrap">{d.name}</span>
              <i className="ri-arrow-right-line text-xs text-foreground-400" />
            </a>
          ))}
        </div>

        <div className="rise-in mt-9 flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
          <a
            href="#hot"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-fire-line text-base" />
            </span>
            查看今日热榜
          </a>
          <a
            href="#live"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition hover:border-foreground-300"
          >
            进入实况快讯
            <i className="ri-arrow-right-line text-sm" />
          </a>
        </div>
      </div>
    </section>
  );
}